import React from 'react';
import PropTypes from 'prop-types';
import RpTargetSuburbFilter from 'components/commons/RpSwitchFilter';
import useFilterStore from 'zustandStore/useFilterStore';
import { LISTINGS, RENTALS, SALES } from '../../constants/comparableTypes';

const TOOLTIP_TEXT = 'Shows the closest properties only within the suburb of the Target property';

const TargetSuburbFilter = React.memo(function TargetSuburbFilter(props) {
    const value = useFilterStore(state => state.filters[props.comparableType].targetSuburbOnly);
    const setFiltersForVariations = useFilterStore(state => state.setFiltersForVariations);

    const handleChange = (checked) => {
        setFiltersForVariations([SALES, LISTINGS, RENTALS], { targetSuburbOnly: checked });
    };

    return (
        <RpTargetSuburbFilter
            tooltip={TOOLTIP_TEXT}
            value={value}
            onChange={handleChange}
            label="Target Suburb Only"
        />
    );
});

TargetSuburbFilter.propTypes = {
    comparableType: PropTypes.oneOf([SALES, LISTINGS, RENTALS]).isRequired,
};

export default TargetSuburbFilter;
